"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MixPanel = void 0;
const app_1 = require("@koopajs/app");
const mixpanel_browser_1 = require("mixpanel-browser");
const lodash_1 = require("lodash");
class MixPanel extends app_1.Plugins.Abstract {
    constructor() {
        super();
        this.key = 'mixpanel';
        app_1.Bus.onConfigReady(({ mixpanel: token }) => {
            if (lodash_1.isEmpty(token)) {
                return console.warn('Mixpanel extension is activated but backend config did not provide a `mixpanel` value');
            }
            mixpanel_browser_1.default.init(token);
            this.dispatchSuccess({});
        });
        app_1.Bus.onUserReady(({ userId }) => {
            if (!mixpanel_browser_1.default) {
                return;
            }
            mixpanel_browser_1.default.identify(userId);
        });
        app_1.Bus.onAnalytics(({ eventName, args, value }) => {
            if (!mixpanel_browser_1.default) {
                return;
            }
            mixpanel_browser_1.default.track(eventName, args);
            if (value) {
                mixpanel_browser_1.default.people.track_charge(value);
            }
        });
    }
}
exports.MixPanel = MixPanel;
//# sourceMappingURL=index.js.map